import React, { useState } from 'react';
import './css/services.css';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div onClick={toggle} className="faq-question">
        <strong>{question}</strong>
        <span>{isOpen ? '▲' : '▼'}</span>
      </div>
      {isOpen && (
        <div className="faq-answer">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQList = () => {
  const faqs = [
     {
    question: 'What is ads management and why do I need it?',
    answer: 'Ads management involves creating, monitoring, and optimizing paid advertising campaigns across platforms like Google Ads, Facebook, Instagram, and LinkedIn. It ensures maximum ROI from your ad spend.',
  },
  {
    question: 'Which advertising platforms do you manage?',
    answer: 'We manage campaigns across Google Ads, Meta Ads (Facebook & Instagram), LinkedIn, YouTube, and programmatic ad networks.',
  },
  {
    question: 'How do you track ad performance?',
    answer: 'We track KPIs such as click-through rates, conversion rates, cost per lead (CPL), and return on ad spend (ROAS), using tools like Google Analytics, Ads Manager, and custom dashboards.',
  },
  {
    question: 'Do you create the ad creatives as well?',
    answer: 'Yes, we offer ad copywriting, graphic design, and video creatives tailored to each platform and campaign objective.',
  },
  {
    question: 'Can you manage ads for both B2B and B2C businesses?',
    answer: 'Absolutely. Our team has experience in running successful ad campaigns for both B2B lead generation and B2C product/service promotion.',
  },
  {
    question: 'How much budget do I need to start running ads?',
    answer: 'We work with budgets of all sizes. A minimum monthly ad spend of AED 1,500–2,000 is recommended for meaningful results, but we tailor strategies based on your goals.',
  },
    // Add more questions and answers as needed
  ];

  return (
    <div>
      {faqs.map((faq, index) => (
        <FAQItem key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
};

const App = () => {
  return (
    <div style={{ padding: '5%' }}>
      <div className="seo-main-faq">
    <div className="seo-main-heading">
      <h1>FAQ’S</h1>
    </div>
      <div className="seo-main-para">
        <p></p>
      </div>
      </div>
      <FAQList />
    </div>
  );
};

export default App;
